








































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {getEnumMap, isEmptyOrWhiteSpace} from '@/utils/Common';
import {showConfirm, showSuccess, showWarning} from "@/utils/UI";
import {API_BIS_CUSTOMFIELD} from "@/configs/Apis";

@Component
export default class CustomField extends Vue {
    @Prop({type: Boolean, required: true, default: () => false})
    visible!: boolean;

    addMetaDataVisible: boolean = false;

    metadataItem = {fieldType: "VARCHAR", label: "", enumValues: "", id: ""};

    changed: boolean = false;

    get metaDataItems() {
        return this.$store.state.project.metadata;
    }

    get isEdit() {
        return !isEmptyOrWhiteSpace(this.metadataItem.id);
    }

    get validateRules() {
        return {
            label: [
                {required: true, message: '请字段名称', trigger: 'blur'}
            ],
            enumValues: [
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if (this.metadataItem.fieldType === "ENUM" && isEmptyOrWhiteSpace(this.metadataItem.enumValues)) {
                            callback(new Error("请输入下拉框中的值"));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ]
        }
    }

    get projectId() {
        const pInfo: any = this.$store.state.project.info || {};
        return pInfo.id || 0;
    }

    formatFieldType(data: any, col: any, value: any) {
        const map = getEnumMap(this.$store.getters["enums/getEnumsByKey"]("FieldType"));
        return map.get(value);
    }

    addMetaData() {
        if (this.metaDataItems && this.metaDataItems.length >= 24) {
            showWarning("标引字段最多添加24个");
            return;
        }
        this.addMetaDataVisible = true;
    }

    saveMetaData() {
        (this.$refs.dataForm as any).validate((isValid: boolean) => {
            if (!isValid) {
                return;
            }

            const requestPath: any = {projectId: this.projectId};
            if (!isEmptyOrWhiteSpace(this.metadataItem.id)) {
                requestPath.id = this.metadataItem.id;
            }
            const postedData: any = {
                label: this.metadataItem.label,
                enumValues: this.metadataItem.enumValues
            };
            if (!isEmptyOrWhiteSpace(this.metadataItem.id)) {
                postedData.id = this.metadataItem.id;
            } else {
                postedData.fieldType = this.metadataItem.fieldType;
            }
            (postedData.hasOwnProperty("id") ? this.$http.put : this.$http.post).call(this.$http, {url: API_BIS_CUSTOMFIELD, path: requestPath}, postedData)
                .then(() => {
                    showSuccess("保存成功");
                    this.$store.dispatch("project/setCustomField", this.$store.state.project.info);
                    this.addMetaDataVisible = false;
                    this.changed = true;
                });
        });
    }

    deleteMataData(field: any) {
        showConfirm("是否删除这个标引字段").then(() => {
            this.$http.delete({url: API_BIS_CUSTOMFIELD, path: {projectId: this.projectId, id: field.id}}, field.id).then(() => {
                showSuccess("删除成功");
                this.$store.dispatch("project/setCustomField", this.$store.state.project.info);
                this.changed = true;
            });
        })
    }

    editMataData(field: any) {
        this.metadataItem = Object.assign({fieldType: "VARCHAR", label: "", enumValues: ""}, JSON.parse(JSON.stringify(field)));
        this.addMetaDataVisible = true;
    }

    closeMetaDataDialog() {
        this.addMetaDataVisible = false;
        this.metadataItem = {fieldType: "VARCHAR", label: "", enumValues: "", id: ""};
    }

    closeDialog() {
        this.$emit("update:visible", false);
        if (this.changed) {
            this.$emit("field-changed");
        }
    }

    @Watch("metadataItem.fieldType")
    onFieldTypeChange() {
        if (this.metadataItem.fieldType !== "ENUM") {
            this.metadataItem.enumValues = "";
        }
    }

    @Watch("addMetaDataVisible")
    oMetaDataVisibleChange() {
        if (!this.addMetaDataVisible) {
            this.metadataItem = {fieldType: "VARCHAR", label: "", enumValues: "", id: ""};
        }
    }
}
